import React,{useEffect,useState}from 'react'
import  {useParams} from 'react-router-dom'
import { API } from '../../api'


const UserProfile = () =>{
   const user = JSON.parse(localStorage.getItem("user"))
   const [profile,setUserProfile] = useState(null)
   const {userid} = useParams()
   console.log(userid)
   useEffect(()=>{
        fetch(`${API}/user/${userid}`,{
            headers:{
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            }
        })
        .then(res=>res.json())
        .then(result=>{
            console.log(result)
            setUserProfile(result)

        })
    },[])

    const followUser = ()=>{
        fetch(`${API}/follow`,{
            method:"put",
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            },
            body:JSON.stringify({
                followId:userid
            })
           
        }) .then(res=>res.json())
        .then(result=>{
            console.log(result)
            localStorage.setItem("user",JSON.stringify(result))
            window.location.reload(false);
        })
    }
    const unfollowUser = ()=>{
        fetch(`${API}/unfollow`,{
            method:"put",
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            },
            body:JSON.stringify({
                unfollowId:userid
            })
           
        }) .then(res=>res.json())
        .then(result=>{
            console.log(result)
            localStorage.setItem("user",JSON.stringify(result))
            window.location.reload(false);
        })
    }

    return(
        <div>
        {profile? 
            
        <div style={{maxWidth:"550px",margin:"0px auto"}}>
        <div style={{
            display:"flex",
            justifyContent:"space-around",
            margin:"18px 0px",
            borderBottom:"1px solid grey"
        }}>
            <div>
                <img style={{width:"160px",height:"160px",borderRadius:"80px"}}
                src={profile.user.photo} alt="hello"
                ></img>
            </div>
            <div>
                <h4 className="brand-logo">{profile.user.name}</h4>
                <h4 className="brand-logo">{profile.user.email}</h4>
                    <div style={{display:"flex",justifyContent:"space-between",width:"108%"}}>
                        <h6>{profile.postes.length} posts</h6>
                        <h6>{profile.user.followers.length} followers</h6>
                        <h6>{profile.user.following.length} following</h6>
                    </div>
             {user.following.includes(userid)?
            <button className="btn waves-effect waves-light brand-logo" onClick={()=>unfollowUser()}>unfollow
            </button> :
            <button className="btn waves-effect waves-light brand-logo" onClick={()=>followUser()}>follow
            </button> 
            }

            </div>
        </div>
        <div className="gallery">
        {
                profile.postes.map(item=>{
                    return(
                    <img key={item._id} src={item.photo} alt={item.title} style={{height:"200px",width:"200px"}}></img>
                    )
                })
            }
          
        </div>
   
    </div>
        :<h2>Loading!...</h2>
        
        }
        </div>
    


    )
}

export default UserProfile